import { type IAdRequest, type IVmap, type IVmapAdBreak } from '@sxmp/ad-sdk-web';

import { type IActionOf } from '../../../../types';
import { Actions } from '../constants';
import {
  type IDequeueAdsPayload,
  type IEnqueueAdsPayload,
  type IReceivingVmapPayload,
  type IRequestAttemptPayload,
  type IRequestFailPayload,
  type IRequestSuccessPayload,
} from '../types';

export function receivingVmap(
  vmap: IVmap,
): IActionOf<Actions.RECEIVING_VMAP, IReceivingVmapPayload> {
  return {
    type: Actions.RECEIVING_VMAP,
    data: {
      vmap,
    },
  };
}

export function enqueueAds(
  ...adBreaks: IVmapAdBreak[]
): IActionOf<Actions.ENQUEUE_ADS, IEnqueueAdsPayload> {
  return {
    type: Actions.ENQUEUE_ADS,
    data: {
      adBreaks,
    },
  };
}

export function dequeueAds(
  ...adBreaks: IVmapAdBreak[]
): IActionOf<Actions.DEQUEUE_ADS, IDequeueAdsPayload> {
  return {
    type: Actions.DEQUEUE_ADS,
    data: {
      adBreaks,
    },
  };
}

export function resumePlaybackAfterAds(): IActionOf<Actions.RESUME_PLAYBACK_AFTER_ADS> {
  return {
    type: Actions.RESUME_PLAYBACK_AFTER_ADS,
  };
}

export function vmapAdOpportunity(): IActionOf<Actions.VMAP_AD_OPPORTUNITY> {
  return {
    type: Actions.VMAP_AD_OPPORTUNITY,
  };
}

export function requestAttempt(
  request: IAdRequest,
): IActionOf<Actions.AD_REQUEST_ATTEMPT, IRequestAttemptPayload> {
  return {
    type: Actions.AD_REQUEST_ATTEMPT,
    data: {
      request,
    },
  };
}

export function requestSuccess(
  request: IAdRequest,
): IActionOf<Actions.AD_REQUEST_SUCCESS, IRequestSuccessPayload> {
  return {
    type: Actions.AD_REQUEST_SUCCESS,
    data: {
      request,
    },
  };
}

export function requestFail(
  request: IAdRequest,
): IActionOf<Actions.AD_REQUEST_FAIL, IRequestFailPayload> {
  return {
    type: Actions.AD_REQUEST_FAIL,
    data: {
      request,
    },
  };
}
